module.exports = __webpack_public_path__ + "img/teddy_roosevelt_bust.bcfde19b.jpg";